import { render, staticRenderFns } from "./WarningsLog.vue?vue&type=template&id=1bcc5cf0&scoped=true"
import script from "./WarningsLog.vue?vue&type=script&lang=js"
export * from "./WarningsLog.vue?vue&type=script&lang=js"
import style0 from "./WarningsLog.vue?vue&type=style&index=0&id=1bcc5cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc5cf0",
  null
  
)

export default component.exports